export const OVERTIME_WORKLOG_STATUS = {
    PENDING: "PENDING",
    ACCEPTED: "ACCEPTED",
    REJECTED: "REJECTED",
};

export const OVERTIME_WORKLOG_STATUS_DICTIONARY = {
    [OVERTIME_WORKLOG_STATUS.PENDING]: "Pending",
    [OVERTIME_WORKLOG_STATUS.ACCEPTED]: "Accepted",
    [OVERTIME_WORKLOG_STATUS.REJECTED]: "Rejected",
};
